module.exports = __webpack_public_path__ + "images/132_2048.jpg";